export function protectFirstRow() {
  const sheetId = 0;

  let format = {
    "addProtectedRange": {
      "protectedRange": {
        "range": {
          "sheetId": sheetId,
          "startRowIndex": 0,
          "endRowIndex": 1,
        },
        "description": "Protecting first row",
        "warningOnly": true,
      }
    }
  };
  return format;
}


export function hideColumn(table_header, column_name) {

  const column_index = table_header.indexOf(column_name);
  const sheet_id = 0;

  const format = {
    "updateDimensionProperties": {
      "range": {
        "sheetId": sheet_id,
        "dimension": 'COLUMNS',
        "startIndex": column_index,
        "endIndex": column_index + 1,
      },
      "properties": {
        "hiddenByUser": true,
      },
      "fields": 'hiddenByUser',
    }
  };

  return format;
}

export function showColumn(table_header, column_name) {

  const column_index = table_header.indexOf(column_name);
  const sheet_id = 0;

  const format = {
    "updateDimensionProperties": {
      "range": {
        "sheetId": sheet_id,
        "dimension": 'COLUMNS',
        "startIndex": column_index,
        "endIndex": column_index + 1,
      },
      "properties": {
        "hiddenByUser": false,
      },
      "fields": 'hiddenByUser',
    }
  };

  return format;
}

export function setDropdown(table_header, column_name, dropDownList=[]) {
  if (dropDownList.length === 0) {
    return;
  }

  const valueList = dropDownList.map((value) => {
    return {
      "userEnteredValue": value,
    };
  });

  const column_index = table_header.indexOf(column_name);
  const sheet_id = 0;

  const request = {
    "setDataValidation": {
      "range": {
        "sheetId": sheet_id,
        "startRowIndex": 1,
        "startColumnIndex": column_index,
        "endColumnIndex": column_index + 1,
      },
      "rule": {
        "condition": {
          "type": "ONE_OF_LIST",
          "values": valueList
        },
        "strict": true,
        "showCustomUi": true,
      }
    }
  };

  return request;
}

export function setColumnWidth(table_header, column_name, width=50) {

  const sheet_id = 0;
  const column_index = table_header.indexOf(column_name);

  const request = {
    "updateDimensionProperties": {
      "range": {
        "sheetId": sheet_id,
        "dimension": "COLUMNS",
        "startIndex": column_index,
        "endIndex": column_index + 1
      },
      "properties": {
        "pixelSize": width
      },
      "fields": "pixelSize"
    }
  };

  return request;
}


export function highlightColumn(table_header, column_name) {
  const sheetId = 0;
  const column_index = table_header.indexOf(column_name);
  const format = {
    "repeatCell": {
      "range": {
        "sheetId": sheetId,
        "startRowIndex": 0,
        "endRowIndex": 1,
        "startColumnIndex": column_index,
        "endColumnIndex": column_index + 1,
      },
      "cell": {
        "userEnteredFormat": {
          "backgroundColor": {
            "red": 1.0,
            "green": 1.0,
            "blue": 0.0
          },
        }
      },
      "fields": "userEnteredFormat(backgroundColor)"
    }
  };
  return format;
}



// WEBPACK FOOTER //
// ./src/components/gsheet/format.js